<script setup lang="ts">
definePageMeta({
  layout: "no-header-footer",
});

const { story, blok } = await useStoryblokContent();
</script>

<template>
  <div class="page-container">
    <StoryblokComponent v-bind="{ blok, story }" />
  </div>
</template>
